<template>
  <b-form-row>
    <b-modal v-model="showModal" size="xl" button-size="sm" ref="finder" hide-footer :title="prefix + title">
      <DepartamentoSguList @onDblClickUnidadeAdministrativa="unidadeAdministrativaSelect"
        :title="prefix + title + ' >'" />
    </b-modal>

    <lg-form-input-finder v-if="!isModal" @handleClean="unidadeAdministrativaSelect" v-model="localValue"
    
      fieldDescription="nome" :label="label" invalidFeedback="Unidade administrativa deve ser informado!" description=""
      :showClear="!disabled" :disabled="disabled">
      <template #prepend>
        <b-button @click="show" class="btn-input-finder" pressed v-if="!disabled && podeMudarDepartamento">
          <b-icon icon="search" />
        </b-button>
      </template>
    </lg-form-input-finder>
  </b-form-row>
</template>
<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"
import DepartamentoSguList from "../../modules/gerenciamento/departamentosgu/DepartamentoSguList.vue";

export default {
  components: { LgFormInputFinder, DepartamentoSguList },

  props: {
    id: String,
    isModal: {
      type: Boolean,
      default: false
    },
    onselect: Function,
    user: Object,
    value: Object,
    prefix: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },

    podeApagarDepartamento: {
      type: Boolean,
      default: true,
    },

    podeMudarDepartamento: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "Unidade Administrativa",
    },
    label: {
      type: String,
      default: "Unidade Administrativa:",
    },
  },

  data() {
    return {

      showModal: false,
      nome: "",
      localValue: this.value,
    }
  },
  watch: {
    value(newValue) {
      this.localValue = newValue
    },
    localValue(newValue) {
      this.$emit("input", newValue)
    },
  },

  methods: {
    async show() {
      this.showModal = true;
    },

    async unidadeAdministrativaSelect(item) {
      this.localValue = item;
      this.showModal = false;
      this.$emit("onselect", item)
    },
  },
}
</script>
